import type { FC } from "react";
import { LuCircleUserRound } from "react-icons/lu";
import type { Post } from "../../../../types/post.types";
import Icon from "../../../icon/icon";
import PostFooter from "../../components/post-footer/post-footer";
import PostHeader from "../../components/post-header/post-header";
import PostText from "../../components/post-text/post-text";
import * as CSS from "./comment-post.styles";

type CommentPostProps = {
	post: Post;
};

const CommentPost: FC<CommentPostProps> = ({ post }) => {
	return (
		<CSS.Post>
			<PostHeader time={null} type={post.type} />
			<div style={{ marginLeft: 44 }}>
				<CSS.Title>Comment</CSS.Title>
				<PostText postId={post.id} text={post.text} quote />
				<div
					style={{
						display: "flex",
						gap: "0.3rem",
						alignItems: "center",
						marginTop: "0.5rem",
					}}
				>
					<Icon icon={LuCircleUserRound} size={28} />
					<CSS.Author>{post.userName}</CSS.Author>
				</div>
				<PostFooter postId={post.id} postType={post.type} />
			</div>
		</CSS.Post>
	);
};

export default CommentPost;
